import gatewayService from '@/modules/common/services/gatewayService';

const baseRoute = '/v3/ai/ai_smart_replies';

const createSmartReply = async (matterUid, userInputReferenceId, clientUid, populatedText = null, customInstructions = null) => {
  const body = {
    matter_uid: matterUid,
    user_input_reference_id: userInputReferenceId,
    client_uid: clientUid,
    custom_instructions: customInstructions,
    populated_text: populatedText,
  };

  return gatewayService.post(baseRoute, body)
    .then((res) => res.data?.data)
    .catch((error) => {
      console.error('Error creating smart reply:', error);
      throw error;
    });
};

const listSmartReplies = async (matterUid, page = 1, perPage = 20) => {
  const queryParams = {
    page,
    per_page: perPage,
  };

  if (matterUid) {
    queryParams.matter_uid = matterUid;
  }

  return gatewayService.get(baseRoute, queryParams)
    .then((res) => res.data?.data?.smart_replies)
    .catch((error) => {
      console.error('Error fetching smart replies:', error);
      throw error;
    });
};

const getSmartReply = async (uid) => gatewayService.get(`${baseRoute}/${uid}`)
  .then((res) => res.data?.data)
  .catch((error) => {
    console.error('Error fetching smart reply:', error);
    throw error;
  });

export default {
  createSmartReply,
  listSmartReplies,
  getSmartReply,
};
